import React from 'react';
import utils from "../../../../Utils/utils";

const Skeleton = () => {
  return (
    <div className="overview-block store-information">
      <div className='title'>
        <span className={'link-skeleton'} style={{ width: 160, height: 20 }} />
      </div>
      <div className="info-wrapper">
        {
          [1,2,3,4,5,6,7,8,9,10,11].map((el) => (
            <div key={el} className="info-item">
              <div className="info-item-title">
                <span className={'link-skeleton'} style={{ width: 189, height: 20 }} />
              </div>
              <div className="info-item-value">
                <span className={'link-skeleton'} style={{ width: 33 + (el * utils.getRandomNum(1, 5) + utils.getRandomNum(1,5)), height: 20 }} />
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default Skeleton;
